import { useProvideHeadlessUiId } from '@autobid/ui/composables/useProvideHeadlessUiId'
import { TITLE } from '../constants/TITLE'

export const useAppProvides = () => {
  useProvideHeadlessUiId()
  provide('pageTitle', TITLE)
  provide('apiVersionCheckEndpoint', '/api/api-ver')
}
